import React, { FC } from 'react'
import BEMHelper from '@ynap/bem-helper'
import LiveChatOfflineIcon from './LiveChatOfflineIcon'

const bem = new BEMHelper('LiveChatButton')

interface Props {
    brand: string
    language: string
    messages: {
        purchasePath: {
            liveChatHeader: () => string
            liveChatOffline: () => string
        }
    }
}

const LiveChatButton: FC<Props> = ({ brand, language, messages }) => {
    return (
        <div className={bem('wrapper')}>
            <div className={bem('header')}>{messages.purchasePath?.liveChatHeader?.()}</div>
            <div className={bem('innerWrapper')} id={`live-chat-${brand}-${language}-embed-checkout`}>
                <div className={bem('offlineButton')}>
                    <LiveChatOfflineIcon className={bem('icon')} />
                    <div className={bem('offlineText', null, 'live-chat-text')}>{messages.purchasePath?.liveChatOffline?.()}</div>
                </div>
            </div>
        </div>
    )
}

export default LiveChatButton
